import React from "react";

const getFormattedName = (name: string) => {
  return name.replace(" ", "-").toLowerCase();
};

const SlideStoreLink = ({ url, name }: { url: string; name: string }) => {
  let formattedName = getFormattedName(name);

  return (
    <a
      className={`mmmTapesWalmart-slide-store-link_${formattedName}-link`}
      href={url}
      tabIndex={0}
    >
      <img
        src={`${process.env.MEDIA_URL}/media/images/carousel/${formattedName}-badge.svg`}
        alt={`${name} link`}
      />
    </a>
  );
};

export default SlideStoreLink;
